import { render, staticRenderFns } from "./WaybillViewNew.vue?vue&type=template&id=09676421&scoped=true&"
import script from "./WaybillViewNew.vue?vue&type=script&lang=js&"
export * from "./WaybillViewNew.vue?vue&type=script&lang=js&"
import style0 from "./WaybillViewNew.vue?vue&type=style&index=0&id=09676421&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09676421",
  null
  
)

export default component.exports